import NullImageFallBack from 'components/picture/null-picture-fallback';

export default NullImageFallBack;
